/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiNotificationsIdQueryResponse, GetApiNotificationsIdPathParams, GetApiNotificationsId400, GetApiNotificationsId401, GetApiNotificationsId403, GetApiNotificationsId404, GetApiNotificationsId500 } from "../../types/GetApiNotificationsId.ts";
import { getApiNotificationsIdQueryResponseSchema } from "../../zod/NotificationSchemas/getApiNotificationsIdSchema.ts";

function getGetApiNotificationsIdUrl({ id }: { id: GetApiNotificationsIdPathParams["Id"] }) {
  const res = { method: 'GET', url: `/api/notifications/${id}` as const }  
  return res
}

/**
 * @summary Получение PUSH уведомления по идентификатору
 * {@link /api/notifications/:Id}
 */
export async function getApiNotificationsId({ id }: { id: GetApiNotificationsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiNotificationsIdQueryResponse, ResponseErrorConfig<GetApiNotificationsId400 | GetApiNotificationsId401 | GetApiNotificationsId403 | GetApiNotificationsId404 | GetApiNotificationsId500>, unknown>({ method : "GET", url : getGetApiNotificationsIdUrl({ id }).url.toString(), ... requestConfig })  
  return getApiNotificationsIdQueryResponseSchema.parse(res.data)
}